export const withImportedPropertyFilter = (
  filterCriteria,
  isImported,
  isPropertyAdministration,
  isFeatureEnabled = true,
) => {
  const criteria = { ...filterCriteria };
  delete criteria.isImported;
  return {
    ...criteria,
    ...(isPropertyAdministration && isFeatureEnabled && isImported ? { isImported: true } : {}),
  };
};

export const shouldShowImportedPropertyFilter = (isFromHome, isFeatureEnabled) => !isFromHome && isFeatureEnabled;
